// Mantine
import { Button, Modal, TextInput, ActionIcon } from '@mantine/core'
import { useDisclosure } from '@mantine/hooks'
import { useForm } from '@mantine/form'

// React
import { useState } from 'react'

// API
import { useAxiosApi } from '@/hooks/useAxiosApi'

// Icons
import { IconX } from '@tabler/icons-react'

// UI
import Box from '../ui/Box'

export default function ProductionOrderMNPBlock({
    productionOrder,
    loadProductionOrder,
}) {
    const [refToAdd, setRefToAdd] = useState('OF')

    const [opened, handlers] = useDisclosure(false)

    const onChange = (event) => {
        // Keep OF at the beginning of the text input
        if (event.target.value.length < 2) {
            setRefToAdd('OF')
        } else {
            // Accept only numbers after OF
            if (isNaN(event.target.value.slice(2))) {
                return
            }

            setRefToAdd(event.target.value)
        }
    }

    // OF form
    const form = useForm({
        initialValues: {
            refs: [],
        },
    })

    const open = () => {
        // Reset state
        setRefToAdd('OF')
        form.setFieldValue('refs', productionOrder.references ?? [])

        handlers.open()
    }

    // Remove OF from refs
    const removeRef = (ref) => {
        form.setFieldValue(
            'refs',
            form.values.refs.filter((r) => r !== ref)
        )
    }

    // On submit
    const onSubmit = (e) => {
        e.preventDefault()

        addRef()
    }

    // Add OF to refs
    const addRef = () => {
        // Check if ref is not already in refs
        if (form.values.refs.includes(refToAdd)) {
            setRefToAdd('OF')
            return
        }

        // Check if ref is a valid OF
        if (refToAdd.length < 3) {
            return
        }

        form.setFieldValue('refs', [...form.values.refs, refToAdd])
        setRefToAdd('OF')
    }

    // API
    const { requestPatch } = useAxiosApi()

    const save = async () => {
        await requestPatch(`/production-orders/${productionOrder.id}`, {
            references: form.values.refs,
        })

        await loadProductionOrder()

        handlers.close()
    }

    const hasRefs =
        Array.isArray(productionOrder?.references) &&
        productionOrder.references.length > 0

    return (
        <>
            <Box
                title="Références OF"
                action={open}
                actionLabel="Modifier"
            >
                {hasRefs ? (
                    <div className="flex flex-wrap gap-2">
                        {productionOrder.references.map((ref) => (
                            <span
                                key={ref}
                                className="bg-gray-100 text-gray-700 px-3 py-1 rounded-lg text-sm font-medium"
                            >
                                {ref}
                            </span>
                        ))}
                    </div>
                ) : (
                    <span className="text-gray-400 text-sm">
                        Aucune référence OF associée
                    </span>
                )}
            </Box>

            <Modal
                title="Modifier les OF associés"
                centered
                opened={opened}
                onClose={handlers.close}
            >
                <div className="flex flex-col">
                    <div className="flex flex-col gap-2">
                        {form.values.refs.map((ref) => (
                            <div
                                key={ref}
                                className="flex justify-between border p-3 rounded-lg items-center"
                            >
                                <span className="font-medium">{ref}</span>

                                <ActionIcon
                                    variant="subtle"
                                    color="red"
                                    size="sm"
                                    onClick={() => removeRef(ref)}
                                >
                                    <IconX size={14} />
                                </ActionIcon>
                            </div>
                        ))}

                        <form className="flex gap-2" onSubmit={onSubmit}>
                            <TextInput
                                value={refToAdd}
                                onChange={onChange}
                                className="flex-1"
                                placeholder="OF..."
                            />
                            <Button variant="default" onClick={() => addRef()}>
                                Ajouter
                            </Button>
                        </form>
                    </div>

                    <div className="flex mt-5 ml-auto">
                        <Button onClick={save}>Sauvegarder</Button>
                    </div>
                </div>
            </Modal>
        </>
    )
}
